import { startPage, requireSignIn, requireSignInToLike, showToast } from '../main';
import { gallery } from '../lib/api';
import { html, raw } from '../lib/html';
import { patternCard, flipLike } from '../lib/patterns';
import { downloadPdf } from '../lib/download';

const user = startPage();
const params = new URLSearchParams(window.location.search);
const category = params.get('category') || 'all';

const tabs = document.getElementById('categories');
const grid = document.getElementById('gallery-grid');
const status = document.getElementById('gallery-status');
const more = document.getElementById('gallery-more');

let page = 0;
let loading = false;
let finished = false;

async function loadCategories() {
  try {
    const { categories = [] } = await gallery.categories();
    tabs.innerHTML = categories.map((item) => {
      const href = item.category === 'all' ? '/gallery/' : `/gallery/?category=${encodeURIComponent(item.category)}`;
      const active = item.category === category;
      return html`<a href="${href}" class="rounded-full px-4 py-1.5 text-sm font-medium capitalize ${active ? 'bg-pink text-white' : 'text-blue hover:bg-sky'}"${raw(active ? ' aria-current="page"' : '')}>${item.name}</a>`;
    }).join('');
  } catch {
    tabs.hidden = true;
  }
}

async function loadMore() {
  if (loading || finished) return;
  loading = true;
  try {
    const { patterns = [] } = await gallery.patterns(category, page);
    page += 1;
    if (!patterns.length) finished = true;
    grid.insertAdjacentHTML('beforeend', patterns.map((pattern) => patternCard(pattern, { user, category })).join(''));
    const shown = grid.children.length;
    status.textContent = shown ? '' : 'No patterns here yet. Publish one from the studio and it will appear here once approved.';
    status.hidden = Boolean(shown);
  } catch {
    status.hidden = false;
    status.textContent = 'The gallery could not be loaded. Please try again later.';
    finished = true;
  } finally {
    loading = false;
  }
  // Keep filling the page until it scrolls, so the observer has something to watch.
  if (!finished && more.getBoundingClientRect().top < window.innerHeight) loadMore();
}

grid.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-like]');
  if (!button) return;
  event.preventDefault();
  if (!user) return requireSignInToLike();
  const patternId = button.closest('[data-pattern-id]').dataset.patternId;
  const card = button.closest('[data-pattern-id]');
  flipLike(button);
  try {
    await gallery.toggleLike(patternId);
  } catch (error) {
    // The like did not go through, so put the heart back.
    flipLike(card.querySelector('[data-like]'));
    if (error.status === 401) requireSignInToLike();
    else showToast('Your like could not be saved. Please try again.');
  }
});

function closeMenus(except = null) {
  grid.querySelectorAll('[data-download-menu]').forEach((menu) => {
    if (menu === except) return;
    menu.querySelector('[data-download-list]').classList.add('hidden');
    menu.querySelector('[data-download-toggle]').setAttribute('aria-expanded', 'false');
  });
}

// Size menu on each card: the icon opens it, a size starts the download.
grid.addEventListener('click', async (event) => {
  const toggle = event.target.closest('[data-download-toggle]');
  if (toggle) {
    event.preventDefault();
    const menu = toggle.closest('[data-download-menu]');
    const list = menu.querySelector('[data-download-list]');
    const open = list.classList.contains('hidden');
    closeMenus(menu);
    list.classList.toggle('hidden', !open);
    toggle.setAttribute('aria-expanded', String(open));
    return;
  }

  const choice = event.target.closest('[data-download-format]');
  if (!choice) return;
  event.preventDefault();
  const menu = choice.closest('[data-download-menu]');
  closeMenus();
  if (!user) return requireSignIn();

  const total = menu.querySelector('[data-download-total]');
  try {
    await downloadPdf(choice.dataset.patternId, choice.dataset.downloadFormat);
    total.textContent = String(Number(total.textContent) + 1);
  } catch (error) {
    if (error.status === 401) requireSignIn();
    else window.alert(`This pattern has no ${choice.dataset.downloadFormat} PDF. Please choose another paper size.`);
  }
});

document.addEventListener('click', (event) => {
  if (!event.target.closest('[data-download-menu]')) closeMenus();
});
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') closeMenus();
});

new IntersectionObserver((entries) => {
  if (entries.some((entry) => entry.isIntersecting)) loadMore();
}, { rootMargin: '400px' }).observe(more);

loadCategories();
loadMore();
